import Newsletter from '../components/Newsletter';
import Disclosure from '@pixelunion/shopify-cross-border';

export default class StaticFooter {
  constructor(section) {
    this.el = section.el;
    this.newsletterEl = this.el.querySelector('.newsletter');
    this.currencyDisclosureEl = this.el.querySelector('[data-disclosure-currency]');
    this.localeDisclosureEl = this.el.querySelector('[data-disclosure-locale]');
    this.disclosures = [];

    if (this.newsletterEl) {
      this.newsletter = new Newsletter(this.newsletterEl);
    }

    if (this.currencyDisclosureEl) {
      this.disclosures.push(new Disclosure(this.currencyDisclosureEl));
    }

    if (this.localeDisclosureEl) {
      this.disclosures.push(new Disclosure(this.localeDisclosureEl));
    }
  }

  onSectionUnload() {
    this.disclosures.forEach(disclosure => disclosure.unload());
    this.newsletter.unload();
  }
}
